import React from "react";
import { Container, Flex, FormattedPrice, Text } from "../../../components";
import { SelectedPaymentMethod } from "./SelectedPaymentMethod";
import { COLOR } from "../../../components/theme";

export const ConfirmPayment = ({
  amount,
  selectedAccount,
  selectedPoints = 0,
  remainingAmount = 0,
}) => (
  <>
    <Container solidDivider solidDividerWidth={2}>
      <Text textStyle="heading5" margin="8 0 2" color={COLOR.BLACK}>
        Confirm payment
      </Text>

      <Text margin="6 0 4"color={COLOR.BLACK}>
        <strong>Payment method</strong>
      </Text>

      <SelectedPaymentMethod selectedAccount={selectedAccount} backgroundColor={COLOR.GREY_60} />
      
      <Text margin="6 0 0" color={COLOR.BLACK}>
        <strong>Summary</strong>
      </Text>

      <Flex padding="8px 0 0">
        <Text color="grey.t75">Your purchase</Text>
        <FormattedPrice price={amount} align="right" />
      </Flex>

      <Flex padding="8px 0 0">
        <Text color="grey.t75">Points</Text>
        <Text color="grey.t75">{parseInt(selectedPoints, 10)} pts</Text>
      </Flex>

      <Flex padding="8px 0 12px">
        <Text color="grey.t75">Plus pay</Text>
        <FormattedPrice price={remainingAmount} align="right" />
      </Flex>
    </Container>

    <Container margin="1 0 0">
      <Flex padding="12px 0 0">
        <Text color={COLOR.BLACK}>
          <strong>Remainder to pay</strong>
        </Text>
        <FormattedPrice price={remainingAmount} align="right" textColor={COLOR.BLACK} />
      </Flex>
    </Container>
  </>
);
